import CommunityV5 from '../components/community/CommunityV5';

// The approved V5 Community is now the canonical public Community page.
export default CommunityV5;
